import React, { useState } from "react";
import "../styles/AddMatchPopup.css";
import { add_ball } from "../api/serverWrapper"; // Or update_ball for edit

export default function EditBallPopup({
  drsTypes,
  matchData,
  onClose,
  loadData,
  cricketAsscotions,
  existingBallData, // If provided, it’s Edit Mode
}) {
  const [ballData, setBallData] = useState(
    existingBallData || {
      Id: "-1",
      MatchId: "",
      DRSTypeId: "",
      Description: "",
      BallUrl: "",
      DRSVideoUrl: "",
      DeploymentSystemId: "",
    }
  );

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [generatedUrl, setGeneratedUrl] = useState("");

  // ✅ Generate URL — used only for preview or saving
  const generateApiUrl = (ballUrl, matchId, overrideDeploymentSystemId) => {
    const regex = /^b_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)$/;
    const match = ballUrl.match(regex);
    if (!match) return "";

    const [, mId, inningNum, overNum, ballNum, extraIndex] = match;

    let deploymentIdToUse = Number(overrideDeploymentSystemId);
    if (!deploymentIdToUse) {
      const selectedMatch = matchData.find((m) => m.MatchId === Number(matchId));
      deploymentIdToUse = selectedMatch?.DeploymentSystemId;
    }

    const selectedAssoc = cricketAsscotions.find(
      (assoc) => assoc.DeploymentSystemId === deploymentIdToUse
    );

    if (!selectedAssoc) return "";

    return `b_${mId}_${inningNum}_${overNum}_${ballNum}_${extraIndex}_${selectedAssoc.DeploymentSystemShortName}`;
  };

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...ballData, [name]: value };
    setError("");

    // Auto-select DeploymentSystemId when Match changes
    if (name === "MatchId") {
      const selectedMatch = matchData.find((m) => m.MatchId === Number(value));
      if (selectedMatch) updatedData.DeploymentSystemId = selectedMatch.DeploymentSystemId || "";
    }

    // Preview URL when BallUrl or DeploymentSystemId changes
    if ((name === "BallUrl" || name === "DeploymentSystemId") && updatedData.BallUrl && updatedData.MatchId) {
      const apiUrl = generateApiUrl(
        name === "BallUrl" ? value : updatedData.BallUrl,
        updatedData.MatchId,
        updatedData.DeploymentSystemId
      );
      setGeneratedUrl(apiUrl);
    }

    setBallData(updatedData);
  };

  // ✅ Save handler — only concatenate DeploymentSystemShortName here
  const handleSave = async () => {
    if (!ballData.MatchId || !ballData.DRSTypeId) {
      setError("Match and DRS Type are required.");
      return;
    }
    if (!ballData.Description) {
      setError("Match Ball Description is required.");
      return;
    }
    if (!ballData.BallUrl) {
      setError("Match BallUrl is required.");
      return;
    }

    const regex = /^b_(\d+)_(\d+)_(\d+)_(\d+)_(\d+)$/;
    if (!ballData.BallUrl.match(regex)) {
      setError("Invalid BallUrl format. Use: b_matchId_inningNumber_overNumber_ballNumber_extraIndex");
      return;
    }

    // ✅ Generate URL only for payload
    const apiUrl = generateApiUrl(ballData.BallUrl, ballData.MatchId, ballData.DeploymentSystemId);

    const payload = { ...ballData };
    if (!ballData.DRSVideoUrl) delete payload.DRSVideoUrl;

    // Only modify for server, not for input field
    payload.BallUrl = apiUrl;

    try {
      setLoading(true);

      // Add or update based on Id
      if (ballData.Id === "-1") {
        await add_ball(payload);
      } else {
        await add_ball(payload); // Replace with update_ball if needed
      }

      onClose();
      loadData();
    } catch (err) {
      console.error("Error saving ball:", err);
      setError("Failed to save ball. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Options
  const renderDrsTypesOptions = () =>
    drsTypes.map((type) => <option key={type.DRSTypeId} value={type.DRSTypeId}>{type.Title}</option>);
  const renderMatchOptions = () =>
    matchData.map((item) => <option key={item.MatchId} value={item.MatchId}>{item.Name}</option>);
  const renderCricketAsscotionsOptions = () =>
    cricketAsscotions.map((assoc) => <option key={assoc.DeploymentSystemId} value={assoc.DeploymentSystemId}>{assoc.DeploymentSystemName}</option>);

  return (
    <div className="popup_overlay">
      <div className="popup_container">
        <div className="popup_header">
          <h2 className="popup_title">{ballData.Id === "-1" ? "Add Ball" : "Edit Ball"}</h2>
          <p className="popup_hint">{ballData.Id === "-1" ? "Enter details for new ball" : "Update the ball details below"}</p>
        </div>

        <div className="popup_body">
          <div className="popup_input_container">
            <select name="MatchId" className="popup_input" value={ballData.MatchId} onChange={handleChange}>
              <option value="">Select Match</option>
              {renderMatchOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <select name="DeploymentSystemId" className="popup_input" value={ballData.DeploymentSystemId} onChange={handleChange}>
              <option value="">Select Cricket Association</option>
              {renderCricketAsscotionsOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <select name="DRSTypeId" className="popup_input" value={ballData.DRSTypeId} onChange={handleChange}>
              <option value="">Select DRS Type</option>
              {renderDrsTypesOptions()}
            </select>
          </div>

          <div className="popup_input_container">
            <input type="text" name="Description" placeholder="Enter Description for Ball" className="popup_input" value={ballData.Description} onChange={handleChange} />
          </div>

          <div className="popup_input_container">
            <input type="text" name="BallUrl" placeholder="Enter Ball Video URL" className="popup_input" value={ballData.BallUrl} onChange={handleChange} />
          </div>
{/* 
          {generatedUrl && (
            <div style={{ marginTop: "10px", fontSize: "14px", color: "green" }}>
              Generated URL (for server): <strong>{generatedUrl}</strong>
            </div>
          )} */}

          {error && <p className="popup_error">{error}</p>}
        </div>

        <div className="popup_footer">
          <button className="popup_btn" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="popup_btn popup_btn_primary" onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : ballData.Id === "-1" ? "Save" : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
}
